<script>
    /**
     * @typedef {Object} Props
     * @property {boolean} [selected] - Boolean indicating if the radio button is selected
     * @property {string} [value] - Value associated with the radio button
     * @property {string} [name] - Group name for the radio buttons
     */
    let { selected = false, value = '', name = '' } = $props();
</script>

<div class="radio-container {selected ? 'selected' : ''}" role="radio" aria-checked={selected}>
    <div class="outer-circle">
        {#if selected}
            <div class="inner-circle">
                <span class="material-icons tick">check</span>
            </div>
        {/if}
    </div>
</div>

<style>
    .radio-container {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 18px;  /* Slightly larger to account for click area */
        height: 18px;
        cursor: pointer;
    }

    .radio-container.selected {
        cursor: default;
    }

    .outer-circle {
        width: 14px; /* Outer circle size */
        height: 14px;
        border: 1px solid #ddd; /* Outer circle border */
        border-radius: 50%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: border-color 0.3s ease;
    }

    .radio-container.selected .outer-circle {
        border-color: rgba(255, 206, 44); /* Selected border color */
    }

    .inner-circle {
        width: 10px;  /* Slightly smaller to reduce the gap */
        height: 10px;
        background-color: rgba(255, 206, 44); /* Inner circle background */
        border-radius: 50%;
        display: inline-flex;  /* Align tick icon inside */
        justify-content: center;
        align-items: center;
    }

    .tick {
        font-size: 8px; /* Exact size of tick icon */
        width: 8px;
        height: 8px;
        line-height: 8px; /* Ensures the tick stays perfectly centered */
        color: black;
    }
</style>
